import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: 'Vasili Savitski',
      email: 'vasili@gmail.com',
      memberSince: '8/12/2020',
      pfp: 'https://picsum.photos/id/22/200/300',
      is2FAEnabled: false,
      role: localStorage.getItem('role') || 'user',
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    setRole(role: string) {
      this.role = role
      localStorage.setItem('role', role)
    },
  },

  getters: {
    isLoggedIn: () => !!localStorage.getItem('token'),
  },
})
